// Shared Learning Center content — used by the public marketing page
// (/learning) and the in-app Resources page (/resources/learning) so both
// stay in sync from one source.
export const LEARNING_CATEGORIES = [
  {
    title: "Getting Started",
    articles: [
      { title: "Your first 10 minutes in GovCo.AI", read: "3 min read", video: "01-first-10-minutes.mp4" },
      { title: "Setting up your company profile", read: "4 min read", video: "02-company-profile.mp4" },
      { title: "Inviting your team and assigning roles", read: "3 min read", video: "03-inviting-team.mp4" },
    ],
  },
  {
    title: "Opportunities & SAM.gov",
    articles: [
      { title: "Running your first SAM.gov sync", read: "4 min read", video: "04-sam-sync.mp4" },
      { title: "Filtering opportunities by NAICS and set-aside", read: "3 min read", video: "05-filtering.mp4" },
      { title: "Turning an opportunity into a proposal", read: "5 min read", video: "06-opportunity-to-proposal.mp4" },
    ],
  },
  {
    title: "AI Drafting",
    articles: [
      { title: "How AI requirement shredding works", read: "5 min read", video: "07-requirement-shredding.mp4" },
      { title: "Generating a first draft with AI Assist", read: "6 min read", video: "08-ai-generate.mp4" },
      { title: "Expand, condense, and rewrite: using inline AI", read: "4 min read", video: "09-inline-ai.mp4" },
    ],
  },
  {
    title: "Compliance & Submission",
    articles: [
      { title: "Building your Compliance Matrix", read: "5 min read", video: "10-compliance-matrix.mp4" },
      { title: "Passing the pre-submission checklist", read: "3 min read", video: "11-checklist.mp4" },
      { title: "Exporting a multi-volume proposal package", read: "4 min read", video: "12-export.mp4" },
    ],
  },
  {
    title: "Collaboration",
    articles: [
      { title: "Locking a section while you edit", read: "2 min read", video: "13-locking.mp4" },
      { title: "Restoring an earlier version", read: "3 min read", video: "14-version-history.mp4" },
      { title: "Running a color-team review", read: "5 min read", video: "15-color-team.mp4" },
    ],
  },
  {
    title: "Administration",
    articles: [
      { title: "Managing users and roles", read: "4 min read", video: "16-manage-roles.mp4" },
      { title: "Reading the audit log", read: "3 min read", video: "17-audit-log.mp4" },
      { title: "Setting up your knowledge base", read: "5 min read", video: "18-knowledge-base.mp4" },
    ],
  },
];
